import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DCTimerComponent } from '@dc/ui/components/timer/timer.component';



@NgModule({
  declarations: [
    DCTimerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DCTimerComponent
  ]
})
export class DCTimerModule { }
